<div>
    <!-- https://www.telerik.com/kendo-angular-ui/components/uploads/fileselect -->
    <!-- Il faut que les credentials soit à false sinon cause des CORS error dans la console... -->
    <kendo-upload 
        [restrictions]="supportedFileTypes"
        [multiple]="true"
        [autoUpload]="false"
        [showFileList]="true"
        [saveUrl]="apiUrl"
        [withCredentials]="false"
        (error)="OnUploadError($event)"
    >
        <ng-template kendoUploadFileInfoTemplate let-files>
            <div *ngFor="let file of files" class="k-file">
                <div class="k-file-info">
                    <span class=" k-file-nam k-file-name-text">{{ file.name }}</span>
                    <span class="k-icon k-i-warning"></span>
                    <span class="k-file-validation-message" *ngIf="(file.validationErrors?.length ?? 0) > 0">{{ file.validationErrors[0].message }}</span>
                    <span class="k-file-validation-message" *ngIf="(file.validationErrors?.length ?? 0) === 0 && file.state === 3">Fichier téléversé</span>
                </div>
            </div>
        </ng-template>
    </kendo-upload>
</div>
